import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material'

const StyledSpan = styled('span')({
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: '2px 7px',
    marginRight: 8,
    marginLeft: -7,
})

const NumberedLabel = ({ label, number }) => (
    <>
        <StyledSpan>{number}</StyledSpan>
        {label}
    </>
)

NumberedLabel.propTypes = {
    label: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
}

export default NumberedLabel
